import { Route } from 'src/routes/Route'

export const TestRoute = Route({ path: '/test-launch-page', hideTopBar: false })
export type TestRoute = Route<typeof TestRoute>
